import type { PresetResponse, FilterResponse, MetricResponse, MetricThresholdType } from "@eu.mdotm.api/sphere";
import { atomWithJsonStorage } from "$root/third-party-integrations/jotai";
import { Map } from "immutable";

export type keyMetricThresholdMapType =
	| {
			thresholdType?: Exclude<MetricThresholdType, "MANUAL">;
			thresholdEntity?: MetricResponse["thresholdEntity"];
			thresholdValue?: MetricResponse["thresholdValue"];
	  }
	| {
			thresholdType: Extract<MetricThresholdType, "MANUAL">;
			thresholdEntity?: undefined;
			thresholdValue: MetricResponse["thresholdValue"];
	  };

export type PortfolioInsightPanelPreset = Omit<PresetResponse, "filters" | "metric"> & {
	search: string;
	filters?: Map<string, FilterResponse>;
	metric?: Omit<MetricResponse, "thresholdType" | "thresholdEntity" | "thresholdValue"> & {
		keyMetricThreshold?: Map<string, keyMetricThresholdMapType>;
	};
};

export const emptyInsightPanelPreset: PortfolioInsightPanelPreset = { search: "" };

export const insightPanelSession$ = atomWithJsonStorage<PortfolioInsightPanelPreset | null>(
	sessionStorage,
	"insightPanelSessionAtom",
	null,
	{
		fromPrimitives(v) {
			const deserialized = v as any;
			return {
				...emptyInsightPanelPreset,
				...deserialized,
				filters: deserialized?.filters && Map(deserialized.filters),
				metric: deserialized?.metric && {
					...deserialized?.metric,
					keyMetricThreshold: deserialized?.metric?.keyMetricThreshold && Map(deserialized.metric.keyMetricThreshold),
				},
			} satisfies PortfolioInsightPanelPreset;
		},
		toPrimitives(newValue) {
			return {
				...newValue,
				filters: newValue?.filters?.toObject(),
				metric:
					newValue?.metric &&
					({
						...newValue.metric,
						keyMetricThreshold: newValue.metric.keyMetricThreshold?.toObject(),
					} satisfies Partial<Record<keyof PortfolioInsightPanelPreset["metric"], unknown>>),
			} satisfies Partial<Record<keyof PortfolioInsightPanelPreset, unknown>>;
		},
	},
);
